import { BaseService } from "core/services";
import { FacilityOrderPatientValidationRouteService } from "application/facility-order/services";

class FacilityOrderPatientValidationService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new FacilityOrderPatientValidationRouteService());
	}

	bulkUpdate(resources) {
        const url = this.routeService.bulkUpdate(resources);
        return this.apiClient.put(url, resources)
    }
}

export default FacilityOrderPatientValidationService;